import {Nullable} from "primereact/ts-helpers";

export class AvailableSlot {
    id!: string;
    available!: number;
    capacity!: number;
    startDateTime!: Date;
    endDateTime!: Date;
    comment: Nullable<string>;
    disabled!: boolean;
}

export class MinimalSlot {
    id!: string;
    capacity!: number;
    startDateTime!: Date;
    endDateTime!: Date;
    comment: Nullable<string>;
}

export class Slot {
    id!: string;
    capacity!: number;
    startDateTime!: Date;
    endDateTime!: Date;
    comment: Nullable<string>;
    bookings!: string[];
    disabled!: boolean;
}

export class NewSlot {
    capacity!: number;
    startDateTime!: Date;
    endDateTime!: Date;
    comment: Nullable<string>;

    constructor(
        capacity: number,
        startDateTime: Date,
        endDateTime: Date,
        comment: Nullable<string> = null,
    ) {
        this.capacity = capacity;
        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        this.comment = comment;
    }
}
